import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';
import type { IAddCarePathSettings } from '../../../../../common/interfaces/addCarePathSettings';

export const PersonalSettingsAddCarePathContext = createContext<{
    defaultProfileSettings?: IAddCarePathSettings;
    setDefaultProfileSettings: Dispatch<SetStateAction<IAddCarePathSettings | undefined>>;
}>({
    defaultProfileSettings: undefined,
    setDefaultProfileSettings: () => undefined,
});
